import React, { useEffect } from "react";
import { Modal, Form, DatePicker, Button, Alert } from "antd";
import moment from "moment";

const ModalExtendExpiry = ({ visible, onClose, onSubmit, user, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && user) {
      form.resetFields();
      const currentExpiry = user.hmo_expires_at ? moment(user.hmo_expires_at) : moment().add(3, "months");
      form.setFieldsValue({
        hmo_expires_at: currentExpiry.isAfter(moment()) ? currentExpiry : moment().add(3, "months"),
      });
    }
  }, [visible, user, form]);

  const handleFinish = async (values) => {
    await onSubmit({
      hmo_expires_at: values.hmo_expires_at.format("YYYY-MM-DD"),
    });
  };

  return (
    <Modal
      title="Extend HMO Expiration Date"
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      zIndex={1100}
    >
      {user && (
        <div style={{ marginBottom: "16px" }}>
          <Alert
            message={`Customer: ${user.name}`}
            description={
              <div>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Provider:</strong> {user.hmo?.name || user.hmo_name || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  <strong>HMO Number:</strong> {user.hmo_number || "N/A"}
                </p>
                <p style={{ margin: "4px 0" }}>
                  <strong>Current Expiration:</strong>{" "}
                  {user.hmo_expires_at
                    ? moment(user.hmo_expires_at).format("DD MMM, YYYY")
                    : "Not Set"}
                </p>
              </div>
            }
            type="info"
            showIcon
          />
        </div>
      )}

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="hmo_expires_at"
          label="New HMO Expiration Date"
          rules={[{ required: true, message: "Please select a new expiration date" }]}
        >
          <DatePicker
            style={{ width: "100%" }}
            disabledDate={(current) => current && current < moment().startOf("day")}
            format="YYYY-MM-DD"
            getPopupContainer={(trigger) => trigger.parentNode}
            popupStyle={{ zIndex: 3000 }}
            dropdownClassName="hmo-datepicker-dropdown"
          />
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "24px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save New Expiration
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalExtendExpiry;
